import React from 'react';
import PropTypes from 'prop-types';

class ListItem extends React.Component {
  getUrl() {
    const { cname, slug, type } = this.props;
    const url = cname ? `//${cname}` : ''

    switch (type) {
      case 'organization':
        return `${url}/organizations/${slug}`;
      case 'portal':
        return `${url}/portals/${slug}`;
      case 'brandguide':
        const brandguideUrl = cname ? `//${cname}` : "https://brandguide.brandfolder.com"
        return `${brandguideUrl}/${slug}`;
      default:
        return `${url}/${slug}`;
    }
  }

  renderCollectionsPrivacyIcon() {
    const { publicPrivacy, stealthPrivacy } = this.props;
    if (publicPrivacy === true && stealthPrivacy === false) {
      return (
        <div className="privacy-pill">
          <div className="circle public" />
          <span aria-hidden className="bff-public" />
        </div>
      );
    }
    if (publicPrivacy === false && stealthPrivacy === false) {
      return (
        <div className="privacy-pill">
          <div className="circle private" />
          <span aria-hidden className="bff-private" />
        </div>
      );
    }
    if (publicPrivacy === false && stealthPrivacy === null) {
      return (
        <div className="privacy-pill">
          <div className="circle private" />
          <span aria-hidden className="bff-private" />
        </div>
      );
    }
    return (
      <div className="privacy-pill">
        <div className="circle stealth" />
        <span aria-hidden className="bff-stealth" />
      </div>
    );
  }

  render() {
    const { name, type } = this.props;

    return (
      <li
        className={`search-dropdown__item search-dropdown__item--${type}`}
        data-testid="search-dropdown-list-item"
      >
        {`${type}` === 'brandfolder'
          && <span aria-hidden className={`bff-grid-view search-dropdown__item--${type}--icon`} />
        }
        {`${type}` === 'brandguide'
          && <span aria-hidden className={`bff-brand-guide search-dropdown__item--${type}--icon`} />
        }
        {`${type}` === 'portal'
          && <span aria-hidden className={`bff-portal search-dropdown__item--${type}--icon`} />
        }
        <a
          aria-label={`${name} ${type}`}
          data-testid="search-dropdown-list-item-link"
          href={this.getUrl()}
        >
          {`${type}` === 'collections' && this.renderCollectionsPrivacyIcon()}
          <span>{name}</span>
        </a>
        {`${type}` === 'organization'
          && <span aria-hidden className="org-label" data-testid="search-dropdown-org-label">Org</span>
        }
      </li>
    );
  }
}

ListItem.propTypes = {
  cname: PropTypes.string,
  name: PropTypes.string.isRequired,
  publicPrivacy: PropTypes.bool,
  slug: PropTypes.string.isRequired,
  stealthPrivacy: PropTypes.bool,
  type: PropTypes.oneOf([
    'organization',
    'brandfolder',
    'collections',
    'portal',
    'brandguide',
  ]).isRequired
};

ListItem.defaultProps = {
  cname: '',
  publicPrivacy: true,
  stealthPrivacy: false
};

export default ListItem;
